import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-12" };
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_6 = { class: "col-md-12" };
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_8 = { class: "mb-0" };
const _hoisted_9 = { class: "col-md-12" };
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_11 = { class: "col-md-12" };
const _hoisted_12 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_QuillEditor = _resolveComponent("QuillEditor");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.userRole === _ctx.UserRole.FRANCHISE)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.uploadLogo && _ctx.uploadLogo(...args)), ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nom * ", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.name) }]),
                                    placeholder: "e.g. Pizza",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.categorieData.name) = $event)),
                                    onChange: _cache[1] || (_cache[1] = (event) => _ctx.handleInput(event, 'name'))
                                }, null, 34), [
                                    [_vModelText, _ctx.categorieData.name]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Description ", -1)),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_QuillEditor, {
                                        theme: "snow",
                                        "content-type": "html",
                                        placeholder: "Donnez une description a la categorie",
                                        toolbar: "full",
                                        content: _ctx.categorieData.description,
                                        "onUpdate:content": _cache[2] || (_cache[2] = ($event) => ((_ctx.categorieData.description) = $event))
                                    }, null, 8, ["content"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nombre de points * ", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validNumberField(_ctx.categorieData.gain) }]),
                                    placeholder: "e.g. Pizza",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.categorieData.gain) = $event)),
                                    onChange: _cache[4] || (_cache[4] = (event) => _ctx.handleInput(event, 'gain'))
                                }, null, 34), [
                                    [_vModelText, _ctx.categorieData.gain]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            (_ctx.actionDetected)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    (_ctx.isLoading)
                                        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                            type: "submit"
                                        }, _toDisplayString(_ctx.actionDetected === 'edit' ? 'Mettre à jour' : ' Ajouter une catégorie'), 3)),
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[5] || (_cache[5] =
                                            //@ts-ignore
                                            (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                        class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                                    }, [...(_cache[10] || (_cache[10] = [
                                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                                            _createElementVNode("span", { class: "position-relative" }, "Annuler", -1)
                                        ]))])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ], 32))
                : _createCommentVNode("", true)
        ])
    ]));
}
